import { AllRmLevelsResponseModel, RmLevelDropDownResponseModel, RmLevelResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { RmLevelIdRequest } from './dto/rm-level-id.request';
import { RmLevelDTO } from './dto/rm-level.dto';
import { RmLevelRequest } from './dto/rm-level.request';
import { RmLevelService } from './rm-level-service';
// import { AllLevelsResponseModel, LevelDropDownResponseModel, LevelDto, LevelResponseModel } from '@gtpl/shared-models/masters';
// import { Level } from './level.entity';
// import { LevelAdapter } from './dto/level.adapter';
// import { LevelDTO } from './dto/level.dto';
// import { LevelRequest } from './dto/level.request';
// import { LevelService } from './level.service';
// import { LevelIdRequest } from './dto/level-id.request';


@ApiTags('rmlevel')
@Controller('rmlevel')
export class RmLevelController {

    constructor(
        private levelService: RmLevelService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler,
      ) {}

      @Post('/createLevel')
      async createLevel(@Body() levelDto:RmLevelDTO,isUpdate:boolean=false,@Req() request:Request): Promise<RmLevelResponseModel> {
          try {
           return await this.levelService.createLevel(levelDto,false,request);
         } catch (error) {
              return this.applicationExceptionHandler.returnException(RmLevelResponseModel, error);
         }
       }
  /**
   * 
   * @returns 
   */
      
  
      @Post('/getAllLevels')
      async getAllLevels(): Promise<AllRmLevelsResponseModel> {
          try {
              return await this.levelService.getAllLevels();
          } catch (error) {
              return this.applicationExceptionHandler.returnException(AllRmLevelsResponseModel, error);
          }
      }
  
       /**
       * Activate Or De-Activate Value Level
       * @param getSingleLevel LevelResponseModel 
       * @returns Value Level
       */
     @Post('/activateOrDeactivateLevel')
     async activateOrDeactivateLevel(@Body() levelReq: RmLevelRequest): Promise<RmLevelResponseModel> {
         try {
             return await this.levelService.activateOrDeactivateLevel(levelReq);
         } catch (err) {
             return this.applicationExceptionHandler.returnException(RmLevelResponseModel, err);
         }
     }
  
      /**
       * creates or updates a value of Level
       * @param LevelDto Level DTO
       * @returns LevelResponse
       */
       @Post('/updateLevel')
       async updateLevel(@Body() levelDto:RmLevelDTO,@Req() request:Request): Promise<RmLevelResponseModel> {
           try {
            return await this.levelService.createLevel(levelDto,true,request);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(RmLevelResponseModel, error);
          }
        }
       @Post('/getLevelByLevelId')
       async getLevelByLevelId(@Body() levelIdRequest:RmLevelIdRequest): Promise<RmLevelResponseModel> {
           try {
            return await this.levelService.getLevelByLevelId(levelIdRequest);
          } catch (error) {
               return this.applicationExceptionHandler.returnException(RmLevelResponseModel, error);
          }
        }
        @Post('/getAllLevelDropDown')
        async getAllLevelDropDown(): Promise<RmLevelDropDownResponseModel> {
            try {
             return await this.levelService.getAllLevelDropDown();
           } catch (error) {
                return this.applicationExceptionHandler.returnException(RmLevelDropDownResponseModel, error);
           }
         }
    

}
